import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=dcde9d0a&scoped=true"
import script from "./StockCard.vue?vue&type=script&lang=js"
export * from "./StockCard.vue?vue&type=script&lang=js"
import style0 from "./StockCard.vue?vue&type=style&index=0&id=dcde9d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcde9d0a",
  null
  
)

export default component.exports